const MAX_CHUNK_SIZE = 500 * 1024; // 500 KB

export class ChunkQueue {
  private chunkQueue: ArrayBuffer[] = [];
  private backupBlobArray: Blob[] = [];

  async enqueueBlobData(blob: Blob): Promise<void> {
    this.backupBlobArray.push(blob);

    try {
      const buffer = await blob.arrayBuffer();
      let offset = 0;

      while (offset < buffer.byteLength) {
        const end = Math.min(offset + MAX_CHUNK_SIZE, buffer.byteLength);
        const slice = buffer.slice(offset, end);
        this.chunkQueue.push(slice);
        offset = end;
      }
    } catch (error) {
      console.error("Error processing blob for queue:", error);
    }
  }

  getNextChunk(): ArrayBuffer | null {
    return this.chunkQueue.shift() ?? null;
  }

  getQueueLength(): number {
    return this.chunkQueue.length;
  }

  getBackupBlob(): Blob {
    return new Blob(this.backupBlobArray, { type: "video/webm" });
  }

  clear(): void {
    this.chunkQueue = [];
    this.backupBlobArray = [];
  }
}
